var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recharge"},[_c('div',{staticClass:"form-horizontal"},[_c('recharge-form',{attrs:{"user":_vm.user,"fee":_vm.fee,"mode":_vm.mode}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-10 col-sm-offset-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.submit}},[_vm._v("确认充值")])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd3587c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Recharge.vue
// module id = yRiw
// module chunks = 1